export default __webpack_public_path__ + "static/media/confectionists-apprentice.79872e87.svg";